module.exports = __webpack_public_path__ + "img/PRODUCT_FILTER_AS_GRID.dc4709d5.svg";